import { render } from "./AuthForm.vue?vue&type=template&id=6c7efa5f&scoped=true"
import script from "./AuthForm.vue?vue&type=script&lang=js"
export * from "./AuthForm.vue?vue&type=script&lang=js"

import "./AuthForm.vue?vue&type=style&index=0&id=6c7efa5f&scoped=true&lang=css"

import exportComponent from "/Users/datis/Developer/ad-impact/web-ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c7efa5f"]])

export default __exports__